import type { ReactNode } from 'react';
import { PageHeader, PageHero } from '@jumpstone/ui-react';

/**
 * Every screen's title block. Thin wrapper over the design system's
 * PageHeader/PageHero so all WagePro screens share one heading rhythm.
 */
export function ScreenHeader({
  title,
  description,
  kicker,
  actions,
}: {
  title: string;
  /** Descriptor paragraph under the title (PageHero calls this the "dek"). */
  description?: string;
  kicker?: string;
  actions?: ReactNode;
}): React.JSX.Element {
  return (
    <PageHeader
      hero={<PageHero kicker={kicker} title={title} dek={description} />}
      actions={actions}
    />
  );
}
